import React, { Component } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class MainBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sliderIndex: 0,
    };
  }

  render() {
    const { sliderIndex } = this.state;
    var settings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      lazyLoad: "progressive",
      afterChange: (index) => {
        this.setState({ sliderIndex: index });
      },
    };
    return (
      <section
        id="section-home-banner"
        data-parallax="scroll"
        data-image-src=""
        data-natural-width="1400"
        data-natural-height="478"
      >
        <div className="banner-container">
          <Slider {...settings} className="haha">
            {/* Banner 0: Delivery */}
            {/* <div className="slide-layer delivery">
              <img
                className={`animated light`}
                src={require("../../assets/img/home_banner/delivery/light.png")}
                alt=""
              />
              <img
                className={`animated phone`}
                src={require("../../assets/img/home_banner/delivery/phone.png")}
                alt=""
              />
              <img
                className={`animated rider ${
                  sliderIndex === 0 ? "slideInLeft" : "d-none"
                }`}
                src={require("../../assets/img/home_banner/delivery/rider.png")}
                alt=""
              />
              <React.Fragment>
                <img
                  className={`animated e-voucher ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/e-voucher.png")}
                  alt=""
                />
                <img
                  className={`animated transport-ticket ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/transport-ticket.png")}
                  alt=""
                />
                <img
                  className={`animated ordering ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/ordering.png")}
                  alt=""
                />
                <img
                  className={`animated snp ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/snp.png")}
                  alt=""
                />
                <img
                  className={`animated prepaid-reload ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/prepaid-reload.png")}
                  alt=""
                />
                <img
                  className={`animated lolol-delivery ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/lolol-delivery.png")}
                  alt=""
                />
                <img
                  className={`animated postpaid-bill ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/postpaid-bill.png")}
                  alt=""
                />
                <img
                  className={`animated mall ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/mall.png")}
                  alt=""
                />
              </React.Fragment>
              <React.Fragment>
                <img
                  className={`animated logo ${
                    sliderIndex === 0 ? "tada" : "d-none"
                  }`}
                  src={require("../../assets/img/home_banner/delivery/logo.png")}
                  alt=""
                />
                <a
                  href="https://itunes.apple.com/my/app/lolol-pay-less-get-more/id1440552007?mt=8"
                  rel="noopener noreferrer"
                  target="_blank"
                  className={`animated download-ios ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                >
                  <img
                    src={require("../../assets/img/home_banner/delivery/download-ios.png")}
                    alt=""
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.lolol.userApp"
                  rel="noopener noreferrer"
                  target="_blank"
                  className={`animated download-android ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                >
                  <img
                    src={require("../../assets/img/home_banner/delivery/download-android.png")}
                    alt=""
                  />
                </a>
              </React.Fragment>
            </div> */}
            {/* END Banner 0: Delivery */}

            {/* Banner 0: Food Delivery */}
            <div className="slide-layer food-delivery">
              {/* <a
              href="/delivery/select-address"
              className="slide-layer food-delivery"
            > */}
              <React.Fragment>
                <a
                  href="https://itunes.apple.com/my/app/lolol-pay-less-get-more/id1440552007?mt=8"
                  rel="noopener noreferrer"
                  target="_blank"
                  className={`animated download-ios ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                >
                  <img
                    src={require("../../assets/img/home_banner/delivery/download-ios.png")}
                    alt=""
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.lolol.userApp"
                  rel="noopener noreferrer"
                  target="_blank"
                  className={`animated download-android ${
                    sliderIndex === 0 ? "fadeIn" : "d-none"
                  }`}
                >
                  <img
                    src={require("../../assets/img/home_banner/delivery/download-android.png")}
                    alt=""
                  />
                </a>
              </React.Fragment>
              {/* </a> */}
            </div>
            {/* END Banner 0: Food Delivery */}
          </Slider>
        </div>
      </section>
    );
  }
}

export default MainBanner;
